export default {
  name: 'foo',

  ui: {
    fooButton: '[js-foo-button]',
    // 'fooLabels[]': '[js-foo-label]',
  },

  events: [
    {
      on: 'hover',
      handle () {
        console.log('[FOO] hover')
      },
    },
    {
      target: 'fooButton',
      on: 'click',
      handle () {
        console.log('[FOO] button click')
      },
    },
  ],

  componentDidMount () {
    console.log('[FOO] did mount')

    const mochArrowFunction = () => {
      console.log('mock arrow function')
    }

    mochArrowFunction()
  },
}
